// Stimulus controller for showing or hiding elements based on the selected value of an input.
//
// Usage:
//
// 1. Selection/Input Field:
//    - Add the following attribute to your select, radio group, or input field:
//      data-action="input->data-kegs--show-hide-selection#showHideElements"
//    - This binds the input event to the showHideElements method.
//
// 2. Elements to Show/Hide:
//    - Each dependent element should have:
//      data-data-kegs--show-hide-selection-target="element"
//      data-dependent-input-type="value"
//    - Replace "value" with the input value that should make the element visible.
//
// Behavior:
//
// - When the user changes the selection, all target elements are checked:
//    - If an element’s data-dependent-input-type includes the selected value, it will be shown (removes 'd-none' class).
//    - Otherwise, it will be hidden (adds 'd-none' class).
//
// Notes:
// - Supports multiple values per element by setting data-dependent-input-type to a comma-separated list, e.g., "option1,option2".
// - Make sure your elements are initially hidden with the `d-none` class if needed.

import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["element"];

  showHideElements(event) {
    const selectedValue = event.currentTarget.value;

    this.elementTargets.forEach((element) => {
      const dependentValues = element.dataset.dependentInputType.split(",").map(value => value.trim());

      if (dependentValues.includes(selectedValue)) {
        element.classList.remove("d-none");
      } else {
        element.classList.add("d-none");
      }
    });
  }
}
